
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allattributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allattributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"TypeScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"align"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type_attr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"display"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hyritage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"val_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iskey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"caption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countvalues"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countproduct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"counttemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incl_sell"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incl_buy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incl_manuf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"technique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suffixe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_unit_m2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"laize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_packaging"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_null"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attributvalues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attribute_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"html_color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countproducts"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":606}};
    doc.loc.source = {"body":"query allattributes($TypeScope: Int) {\r\n  allattributes(TypeScope: $TypeScope) {\r\n    id\r\n    name\r\n    align\r\n    type_attr\r\n    display\r\n    hyritage\r\n    control\r\n    val_type\r\n    fk_unit\r\n    unit\r\n    width\r\n    key\r\n    iskey\r\n    caption\r\n    countvalues\r\n    countproduct\r\n    counttemplate\r\n    created_at\r\n    incl_sell\r\n    incl_buy\r\n    incl_manuf\r\n    default_id\r\n    default\r\n    technique\r\n    suffixe\r\n    fk_unit_m2\r\n    laize\r\n    is_packaging\r\n    is_null\r\n    attributvalues {\r\n      id\r\n      name\r\n      attribute_id\r\n      html_color\r\n      ref\r\n      countproducts\r\n    }\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["allattributes"] = oneQuery(doc, "allattributes");
        
